import React from 'react';
import { Row, Col } from 'antd';
import styles from '../company.module.scss';
import COButton from 'shared/components/COButton';
import { ButtonSize } from 'enums/ButtonEnums';
import { CategoryOptions, convertToOptions } from 'shared/utils/convertOptions';
import { MetaData } from 'models/MetaData/metaData.model';
import { CompanyDashboardProps } from '../constants';
import Dropdown from 'shared/components/Dropdown';
import StewwiLogo from 'assets/images/ENV_Stewwi_HorizontalLogo_RGB_Blue.png';

const STEWWI_URL = 'https://stewwi.com/';

interface HeaderProps {
  parentOrg: string | undefined;
  belongsMetaData: MetaData[];
  locMetaDataByOrg: MetaData[];
  yearsMetaDataByOrg: MetaData[];
  locationOption: string | undefined;
  firstYear?: string | number;
  onOrgChange: (value: string) => void;
  onLocationChange: (value: string) => void;
  onYearChange: (value: string) => void;
  onReset: () => void;
  onSubmit: () => void;
  pieLoading?: boolean;
  loading?: boolean;
  yearEmissionLoading?: boolean;
  showStewwiButton?: boolean;
  title?: string;
}

const Header: React.FC<HeaderProps> = ({
  parentOrg,
  belongsMetaData,
  locMetaDataByOrg,
  yearsMetaDataByOrg,
  locationOption,
  firstYear,
  onOrgChange,
  onLocationChange,
  onYearChange,
  onReset,
  onSubmit,
  pieLoading,
  loading,
  yearEmissionLoading,
  showStewwiButton,
  title,
}) => {
  const convertToOptionsString = (data: MetaData[]) => {
    return data?.map((item: MetaData) => ({
      label: item.label?.toString(),
      value: item.value?.toString(),
    }));
  };

  return (
    <Row justify="center" align="middle">
      <Col span={7}>
        <div className={styles.headerTitleRow}>
          <h3 className={styles.headerTitle}>
            {title ?? CompanyDashboardProps.DASHBOARD}
          </h3>
          {showStewwiButton && (
            <div className={styles.stewwiButton}>
              <COButton
                size={ButtonSize.SMALL}
                onClick={() => window.open(STEWWI_URL, '_blank', 'noopener,noreferrer')}
              >
                <img
                  src={StewwiLogo}
                  alt={CompanyDashboardProps.STEWWI}
                  className={styles.stewwiLogoImg}
                />
              </COButton>
            </div>
          )}
        </div>
      </Col>
      <Col span={17}>
        <Row
          justify="center"
          align="middle"
          gutter={[30, 20]}
          className={styles.rightContentArea}>
          <Col span={6}>
            <label>{CompanyDashboardProps.SelectOrganization}</label>
            <Dropdown
              value={parentOrg}
              onChange={onOrgChange}
              options={convertToOptions(belongsMetaData)}
              placeholder={CompanyDashboardProps.SELECT_TEXT}
            />
          </Col>
          <Col span={6}>
            <label>{CompanyDashboardProps.SelectLocations}</label>
            <Dropdown
              allowClear
              value={locationOption}
              onChange={onLocationChange}
              options={convertToOptions(locMetaDataByOrg)}
              placeholder={CompanyDashboardProps.SELECT_TEXT}
            />
          </Col>
          <Col span={6}>
            <label>{CompanyDashboardProps.SelectYear}</label>
            <Dropdown
              value={String(firstYear)}
              onChange={onYearChange}
              options={convertToOptionsString(yearsMetaDataByOrg)}
              placeholder={CompanyDashboardProps.SELECT_TEXT}
            />
          </Col>
          <Col span={6}>
            <div className={styles.sideButtons}>
              <Row justify="center" align="middle">
                <Col span={8}>
                  <div onClick={onReset} className={styles.reset}>
                    {CompanyDashboardProps.RESET}
                  </div>
                </Col>
                <Col span={14}>
                  <COButton size={ButtonSize.SMALL} loading={ yearEmissionLoading || loading || pieLoading } onClick={onSubmit}>
                    {CompanyDashboardProps.APPLY}
                  </COButton>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Header;
